import { useTranslation } from 'react-i18next'

import { TaskPriority } from '../../api/tasksApi'

interface IProps {
  priority: TaskPriority
}

export default function PriorityIcon({ priority }: IProps) {
  const { t } = useTranslation()

  let icon = null
  let color = 'grey'
  switch (priority) {
    case 'trivial':
      icon = 'fas fa-arrow-down'
      break
    case 'minor':
      icon = 'fas fa-angle-double-down'
      color = 'success'
      break
    case 'medium':
      icon = 'fas fa-arrow-up'
      color = 'danger'
      break
    case 'critical':
      icon = 'fas fa-angle-double-up'
      color = 'danger'
      break
    case 'blocker':
      icon = 'fas fa-ban'
      color = 'danger'
      break
    default:
      icon = 'fas fa-question'
  }

  return (
    <span
      className={`icon tooltip is-tooltip-right has-text-${color}`}
      data-tooltip={t(`task.priorities.${priority}`)}
    >
      <i className={icon} />
    </span>
  )
}
